<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Painel de controle</span>
        <h3 class="page-title">Visão Global</h3>
      </d-col>
    </d-row>

    <template v-if="userType == 1">
      <dashboard-admin />
    </template>
    <template v-if="userType == 2">
      <dashboard-staff />
    </template>
    <template v-if="userType == 3">
      <dashboard-customer />
    </template>

  </d-container>
</template>

<script>
import DashboardAdmin from './DashboardAdmin.vue';
import DashboardStaff from './DashboardStaff.vue';
import DashboardCustomer from './DashboardCustomer.vue';

export default {
  components: {
    DashboardAdmin,
    DashboardStaff,
    DashboardCustomer,
  },
  methods: {
  },
  computed: {
    userType() {
      const { user } = this.$store.state.user;
      if (user && user.settings) {
        return user.settings.user_type_id;
      }
      return 0;
    },
  },
  mounted() {},
};
</script>

